import React, { useState, useEffect } from "react";
import { createSearchParams, useParams, useLocation, useNavigate } from "react-router-dom";
import { hubLabsGet } from "../utils/hubLabsApiRequest";
import EventboardList from "../components/EventboardList";
import Loading from "../components/Loading";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

/**
 * ---------------------------------------------
 * Eventboard notes
 * Specialist leaderboard fo use at 1-2 day events
 * Auto update components evey x seconds
 * ---------------------------------------------
 **/


function Eventboard() {
  document.title = "Wattbike Hub Eventboards";
  const navigate = useNavigate();

  // Get object ID from URL
  let { workoutId } = useParams();

  // Get optional query params. Mainly filters on the displayed data
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  // dates
  const dateNow = new Date(); // deault to starting now if not had anything
  dateNow.toISOString();
  let futureDate = new Date();
  futureDate.setHours(dateNow.getHours() + (24 * 30)); // default to x days in the future
  futureDate.toISOString();

  // Set up some variables that will trigger UI updates
  const refreshRate = 10000; // ms to refresh the data at
  const [loading, setLoading] = useState(false);
  const [workout, setWorkout] = useState(workoutId);
  const [sessions, setSessions] = useState();
  const [lastUpdated, setLastUpdated] = useState('');
  const [totalEntries, setTotalEntries] = useState([]);
  const [totalAttempts, setTotalAttempts] = useState([]);
  const [orderedBy, setOrderedBy] = useState(searchParams.get("sort"));
  const [limit, setLimit] = useState(searchParams.get("limit") ? searchParams.get("limit") : 1000);
  const [serialNumbers, setSerialNumbers] = useState(searchParams.get("serials"));
  const [userIds, setUserIds] = useState(searchParams.get("users")); // e.g. PBXEZ1PJw7,hq25PZuDRX,FFV868xOmZ
  const [startDate, setStartDate] = useState(searchParams.get("start") ? new Date(searchParams.get("start")).toISOString() : dateNow); // deault to starting now if not had anything
  const [endDate, setEndDate] = useState(searchParams.get("end") ? new Date(searchParams.get("end")).toISOString() : futureDate); // default to x days in the future
  const [time, setTime] = useState(Date.now());
  const [autoUpdate, setAutoUpdate] = useState(searchParams.get("au") === '1' ? true : false || false);
  const [title, setTitle] = useState(searchParams.get("title") || '');
  const [displayControls, setDisplayControls] = useState(searchParams.get("dc") === '1' ? true : false || false);

  // onload
  useEffect(() => {
    fetchData().catch("Fetching sessions data error: ", console.error);
  }, []);

  const fetchData = async () => {
    setLoading(true);

    // todo: validate all params
    const serialsRegex = new RegExp('[-,0-9]+'); // https://regex101.com/
    if (serialNumbers && !serialsRegex.test(serialNumbers)) { console.log("Invalid serials"); }

    // build request params
    let params = {
      workoutId: workoutId,
      startDate: startDate,
      endDate: endDate,
      limit: limit,
      sort: orderedBy
    }

    // make the request
    let sessionsList;
    try {
      sessionsList = await getEventboardSessions(params);
    } catch (error) {
      console.log(error);
    }

    if (sessionsList) {
      // await setDisplayControls(searchParams.get("dc"));
      await setSessions(sessionsList.sessions);
      // await setWorkout(sessionsList.workout.id);
      await setTotalEntries(sessionsList.fullCount);
      await setTotalAttempts(sessionsList.fullAttemptsCount);

      // calc and add last updated time
      let lastUpdatedString;
      let dateNow = new Date;
      let lastUpdatedDateObject = new Date(sessionsList.lastUpdated);
      var diff = (dateNow.getTime() - lastUpdatedDateObject.getTime()) / 1000; // get seconds difference
      if (diff < 5) {
        lastUpdatedString = `Just now`;
      } else if (diff < 120) {
        lastUpdatedString = `${Math.abs(Math.round(diff))} seconds ago`;
      } else {
        lastUpdatedString = `${Math.abs(Math.round(diff / 60))} minutes ago`;
      }
      await setLastUpdated(lastUpdatedString);
    }

    setLoading(false);
  };


  // timer used to autorefresh. If autorefresh is toggled on
  useEffect(() => {
    if (autoUpdate) {
      const interval = setInterval(() => setTime(Date.now()), refreshRate);
      return () => {
        clearInterval(interval);
      };
    }
  }, [autoUpdate]);


  //
  const styles = {
    container: {
      maxWidth: 1200,
      margin: "0 auto",
      padding: '0'
    },
    header: {
      textAlign: 'center'
    }
  };

  // save workout ID and sort value
  const handleWorkoutChange = (url) => {

    const bits = url.split('?');
    console.log("new workout ID: ", bits[0]);
    setWorkout(bits[0]);

    const params = new URLSearchParams(bits[1]);
    setOrderedBy(params.get("sort"));

  }

  const handleLeaderboardUpdate = () => {

    let newUrl = `/eventboard/${workout}`;
    newUrl += `?sort=${orderedBy}`;
    if (serialNumbers) { newUrl += `&serials=${serialNumbers}` };
    if (userIds) { newUrl += `&users=${userIds}` };
    if (title) { newUrl += `&title=${title}` };
    if (startDate) { newUrl += `&start=${startDate}` };
    if (endDate) { newUrl += `&end=${endDate}` };

    console.log("newUrl: ", newUrl);

    // go to new challenge
    navigate(newUrl);
    fetchData().catch("Fetching sessions data error: ", console.error);

  }

  return (
    <>
      <div style={styles.container}>
        <div style={styles.header}>
          <h1>{title ? title : workout.title}</h1>

          {displayControls ? (
            <>
              <Form.Control
                as="select"
                className="form-select form-select-override"
                // value=''
                onChange={(event) => { handleWorkoutChange(event.target.value); }}
                style={{ "margin": "0 auto", "padding": 5, "width": 300, "fontSize": "1.2em" }}
              >
                <option value="">Select an activity.</option>
                <optgroup label="Challenges">
                  <option value="Yn6ZH2XvuK?sort=time">200m Challenge (time)</option>
                  <option value="wo-1k-distance?sort=time">1k Challenge (time)</option>
                  <option value="wo-5k-distance?sort=time">5k Challenge (time)</option>
                  <option value="vlt7tw8qk2?sort=time">10k Challenge (time)</option>
                  <option value="HInpZ6sYoG?sort=time">15k Challenge (time)</option>
                </optgroup>
                <optgroup label="Tests">
                  <option value="wo-6sec-test?sort=powerMax">6 Sec Test (max power)</option>
                  <option value="wo-30sec-test?sort=powerAvg">30 Sec Test (avg power)</option>
                  <option value="wo-0356757975062e92?sort=powerAvg">20 Min FTP Test (avg power)</option>
                  {/* <option value="/leaderboard/wo-a3-standard?sort=powerKg">A3 Test (W/kg)</option> */}
                </optgroup>
                <optgroup label="Climbs">
                  <option value="wo-climb-box-hill?sort=time">Box Hill (time)</option>
                </optgroup>
                <optgroup label="Summer Sessions">
                  <option value="TCsHqET9Lo?sort=time">The Tour - Col Bayard (time)</option>
                </optgroup>

              </Form.Control>

              <Form.Control
                id="filterSearchMobile"
                type="text"
                placeholder="Comma, seperated, serial, numbers"
                value={serialNumbers}
                onChange={(event) => { setSerialNumbers(event.target.value); }}
                style={{ "textAlign": "center", "margin": "0 auto", "padding": 5, "width": 300, "fontSize": "1.2em" }}
              />

              <Form.Control
                id="filterTitle"
                type="text"
                placeholder="title"
                value={title}
                onChange={(event) => { setTitle(event.target.value); }}
                style={{ "textAlign": "center", "margin": "0 auto", "padding": 5, "width": 300, "fontSize": "1.2em" }}
              />

              <Form.Control
                id="filterUserIds"
                type="text"
                placeholder="Comma, seperated, user, ids"
                value={userIds}
                onChange={(event) => { setUserIds(event.target.value); }}
                style={{ "textAlign": "center", "margin": "0 auto", "padding": 5, "width": 300, "fontSize": "1.2em" }}
              />

              <Form.Control
                id="filterStartDate"
                type="text"
                placeholder="Start date"
                value={startDate}
                onChange={(event) => { setStartDate(event.target.value); }}
                style={{ "textAlign": "center", "margin": "0 auto", "padding": 5, "width": 300, "fontSize": "1.2em" }}
              />

              <Form.Control
                id="filterEndDate"
                type="text"
                placeholder="End date"
                value={endDate}
                onChange={(event) => { setEndDate(event.target.value); }}
                style={{ "textAlign": "center", "margin": "0 auto", "padding": 5, "width": 300, "fontSize": "1.2em" }}
              />

              <p>AutoUpdate:
                <Form.Check
                  id="autoUpdateCheckbox"
                  // type="checkbox"
                  defaultChecked={autoUpdate}
                  value={autoUpdate}
                  onChange={(event) => { setAutoUpdate(event.target.checked); }}
                  style={{ "textAlign": "center", "margin": "0 auto", "padding": 5, "width": 10, "fontSize": "1.2em" }}
                />
              </p>

              <Button variant="primary" onClick={handleLeaderboardUpdate}>Update</Button>
            </>
          )
            : (<></>)}
        </div>

        {loading ? (
          <></>// <Loading label={"general-loading"} />
        ) : (
          <EventboardList timer={time} data={sessions} workout={workout} orderedBy={orderedBy} serialNumbers={serialNumbers} />
        )}
      </div>
    </>
  );
}

//////////////////////////////////////////////////////////////
// Get challenge sessions
//////////////////////////////////////////////////////////////
const getEventboardSessions = async (params = {}) => {
  // compile all options
  let requestOptions = {
    resource: "leaderboard",
    params: params,
    cache: false,
  };

  // run the query
  let response = await hubLabsGet(requestOptions);
  return response;
};

export default Eventboard;
